/**
 * Stimulus controller that toggles a button's disabled state based on input value.
 * The button is disabled when the input field is empty or contains only whitespace.
 * @example
 * // HTML usage:
 * // <div data-controller="submit-toggle">
 * //   <input type="text" data-submit-toggle-target="input" data-action="input->submit-toggle#toggle">
 * //   <button data-submit-toggle-target="button">Submit</button>
 * // </div>
 */
import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input', 'button'];

  connect() {
    this.toggle();
    this.inputTarget.focus();
  }

  toggle() {
    this.buttonTarget.disabled = this.inputTarget.value.trim() === '';
  }
}
